<template>
  <div class="sf-page">
    <top-header v-bind:title="$t('company')" />
    <div class="sf-container">
      <v-card class="sf-card"
              flat>
        <v-card-text class="sf-card__body">
          <p class="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Id quia eos maiores incidunt expedita rerum velit error perspiciatis inventore unde et tempora temporibus, recusandae at sapiente. Distinctio, adipisci? Ut, quidem.</p>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
  import TopHeader from '@/components/common/TopHeader'

  export default {
    components: {
      TopHeader
    },
    name: 'Company'
  }
</script>

<i18n>
  {
    "de": {
      "company": "Unternehmen"
    },
    "en": {
      "company": "Company"
    }
  }
</i18n>